import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

import { TopButton } from '../../atoms';
import { Nav } from '../../molecules';
import { HeaderBar } from '../../organisms';

const Content = styled.div`
  width: 640px;
  margin: ${theme.spacing.xl} auto 0;
  padding-bottom: 100px;
`;

const NavContainer = styled.div`
  min-height: calc(100vh - ${theme.headerHeight});
  background-color: white;
  white-space: nowrap;
  box-sizing: border-box;
  padding: ${theme.spacing.xl};
  transform: translate(-${theme.spacing.xl});
  position: sticky;
  align-self: flex-start;
  top: 80px;
  z-index: 1;

  ${theme.mediaQuery('tablet')} {
    position: fixed;
    transform: translate(-130%);
    transition: 0.2s ease-in-out;

    &.active {
      transform: translate(-${theme.spacing.xl});
      box-sizing: border-box;
    }
  }
`;

const DimmedBg = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.2);
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};

  ${theme.mediaQuery('tablet', 'min')} {
    display: none;
  }
`;

const links = [
  {
    to: { pathname: '/' },
    text: '홈',
    name: 'home',
  },
  {
    to: { pathname: '/questions' },
    text: '내가 쓴 질문',
    name: 'question',
  },
  {
    to: { pathname: '/likes' },
    text: '좋아요한 질문',
    name: 'likes',
  },
];

const DefaultTemplate = ({ children, ...props }) => {
  const [isVisible, setVisible] = useState(false);

  const handleToggle = () => {
    setVisible((state) => !state);
  };

  return (
    // eslint-disable-next-line react/prop-types
    <div style={{ ...props.style }}>
      <HeaderBar avatarAlt="avater" onToggleNav={handleToggle} />
      <div
        style={{
          display: 'flex',
          maxWidth: 1280,
          margin: 'auto',
          padding: `0 ${theme.spacing.xl}`,
          boxSizing: 'border-box',
        }}
      >
        <DimmedBg
          isVisible={isVisible}
          onClick={isVisible ? handleToggle : undefined}
        />
        <NavContainer className={isVisible && 'active'}>
          <Nav links={links} />
        </NavContainer>
        <Content>{children}</Content>
        <TopButton
          style={{
            position: 'fixed',
            right: theme.spacing.xxl,
            bottom: theme.spacing.xl,
          }}
        />
      </div>
    </div>
  );
};

DefaultTemplate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DefaultTemplate;
